module.exports = __webpack_public_path__ + "assets/img/KeyReport_gontard.ddd644e8-ps.jpg";